import { NgModule } from "@angular/core";
import { AutofocusDirective } from "./auto-focus.directive";

@NgModule({
    imports: [],
    declarations: [AutofocusDirective],
    exports: [AutofocusDirective],
})
export class AutoFocusDirectiveModule {}
